const ScheduleAccessSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-white px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">診療時間</h2>
        
        <div className="max-w-5xl mx-auto overflow-x-auto">
          <div className="bg-white rounded-3xl shadow-lg overflow-hidden min-w-[640px]">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-[#007bbb]">
                  <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">診療時間</th>
                  <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">月</th>
                  <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">火</th>
                  <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">水</th>
                  <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">木</th>
                  <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">金</th>
                  <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">土</th>
                  <th className="text-center py-5 px-4 text-white font-bold text-lg">日</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-6 px-4 text-center font-semibold text-gray-900 bg-gray-50 border-r border-gray-200">9:00～12:30</td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto">
                      <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[14px] border-b-gray-900"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto">
                      <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[14px] border-b-gray-900"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto">
                      <span className="text-2xl font-bold text-gray-900">×</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="py-6 px-4 text-center font-semibold text-gray-900 bg-gray-50 border-r border-gray-200">14:30～18:30</td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto">
                      <span className="text-2xl font-bold text-gray-900">×</span>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                      <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center border-r border-gray-200">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto">
                      <span className="text-2xl font-bold text-gray-900">×</span>
                    </div>
                  </td>
                  <td className="py-6 px-4 text-center">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto">
                      <span className="text-2xl font-bold text-gray-900">×</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="bg-white px-8 py-6 text-sm text-gray-700 space-y-2">
              <p><span className="inline-block w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[10px] border-b-gray-900 mr-2 align-middle"></span>:水・土曜の午前・・・9:00～13:00</p>
              <p><span className="text-xl font-bold mr-2">×</span>:休診・・・水・土曜の午後、日曜、祝日</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleAccessSection;
